import React from 'react';
import { Footer } from '@/features/marketplace/components/footer';
import { HowToJoinSection } from './containers/how-to-join-section';
import { HeroSection } from './containers/hero-section';
import { DiscoverYourNewHomeSection } from './containers/discover-your-new-home-section';
import { WhyJoinUsSection } from './containers/why-join-us-section';
import { CommunityEventsSection } from './containers/community-events-section';
import { NewsletterSection } from './containers/newsletter-section';
import { WhatOurHousematesSaySection } from './containers/what-our-housemates-say-section';
import { FindYourNextHomeSection } from './containers/find-your-next-home-section';
import { QuotationSection } from './containers/quotation-section';
import { FollowUsSection } from './containers/follow-us-section';
import { ReactQueryProvider } from '@/providers/react-query-provider';
import { AuthContextProvider } from '@/hooks/use-auth';
import { MarketPlaceHeader } from '@/features/marketplace/components/header';
import { HeaderVisibilityProvider } from '@/contexts/header-visibility-context';

const Home = () => {
  return (
    <ReactQueryProvider>
      <AuthContextProvider>
        <HeaderVisibilityProvider>
          <MarketPlaceHeader />
          <HeroSection />
          <DiscoverYourNewHomeSection />
          <WhyJoinUsSection />
          <HowToJoinSection />
          <WhatOurHousematesSaySection />
          <FindYourNextHomeSection />
          <NewsletterSection />
          <CommunityEventsSection />
          <QuotationSection />
          <FollowUsSection />
          <Footer />
        </HeaderVisibilityProvider>
      </AuthContextProvider>
    </ReactQueryProvider>
  );
};

export { Home };
